import DOMPurify from 'dompurify'
import React from 'react'
import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import Modal from '../../../../components/common/Modal'
import { api } from '../../../../configs/api'
import { useBusiness } from '../../../../context/BusinessContext'
import { NoteType } from './BusinessNotes'
import { NotesProps } from '../../../../components/common/Notes'

const BusinessNoteDelete = ({
    open,
    handleClose,
    handleCloseForm,
    data,
    setData
}: {
    open: boolean
    handleClose: () => void
    handleCloseForm: () => void
    data: NoteType | null
    setData: (data: any) => void
}) => {
    const { loadBusiness } = useBusiness()
    const form = useForm({ mode: 'onChange' })
    const formRef = React.useRef<HTMLFormElement>(null)

    const handleDelete = async () => {
        if (!data) return
        const id = data.id
        if (!id) {
            toast.error('Nota não encontrada!')
            return
        }

        try {
            const response = await fetch(`${api}business/note/delete`, {
                method: 'POST',
                body: JSON.stringify({ noteID: id })
            })

            const result = await response.json()
            if (!result.success) {
                toast.error(result.message || 'Erro ao excluir o nota!')
                return
            }

            // Atualiza o contexto removendo a nota
            setData((prevData: any) => ({
                ...prevData,
                notes: prevData.notes.filter((item: NotesProps['data'][number]) => item.id !== id)
            }))

            toast.success('Nota excluída com sucesso!')
            handleClose()
            handleCloseForm()
        } catch (error) {
            console.log(error)
        }
    }

    if (!open || !data) return null

    return (
        <Modal
            open={open}
            handleClose={handleClose}
            title='Excluir nota'
            maxWidth='max-w-xl'
            handleDelete={() => formRef.current?.requestSubmit()}
            canDelete
        >
            <form ref={formRef} onSubmit={form.handleSubmit(handleDelete)}>
                <div className='text-gray-800 dark:text-white/90'>
                    <p>
                        Tem certeza que deseja exluir a nota?
                        <strong className='text-error-400'> Esta ação é irreversível.</strong>
                    </p>
                    <p
                        className='text-sm mt-3 line-clamp-6 italic opacity-80'
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.description) }}
                    />
                </div>
            </form>
        </Modal>
    )
}

export default BusinessNoteDelete
